/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Checkbox, Table } from '@cambridgeassessment/cambridge-ui';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db';
import { CheckboxStyled } from '../ManageSampleChanges.styles';
import { sortLearners, TableSortConfig } from '../helpers';
import { baseTableCols } from '../baseTableCols';

interface Props {
  filteredLearnersList: Entry[];
  newLearners: Entry[];
  setNewEntries: (entries: Entry[]) => void;
  isPartOfConsortia: boolean;
  maxMark?: number;
}

export const AddLearnersTable = (props: Props): JSX.Element => {
  const {
    filteredLearnersList,
    setNewEntries: setCheckedLearners,
    newLearners: checkedLearners,
    isPartOfConsortia,
    maxMark,
  } = props;
  const qaId = 'additional';
  const [sortConfig, setSortConfig] = useState<TableSortConfig>();

  const filteredAndSortedList = [...filteredLearnersList];

  sortLearners(filteredAndSortedList, sortConfig);

  const onCheckboxClick = (item: Entry) => {
    const alreadyChecked = checkedLearners.some((x) => item._id === x._id);

    if (alreadyChecked) {
      setCheckedLearners([...checkedLearners.filter((x) => x._id !== item._id)]);
    } else {
      setCheckedLearners([...checkedLearners, item]);
    }
  };

  const renderSingleCheckbox = (item: Entry): JSX.Element => {
    return (
      <CheckboxStyled>
        <Checkbox
          dataQaId={`learner-checkbox-${item.learner?.number}`}
          checked={checkedLearners.filter((x) => x._id === item._id).length > 0}
          onChange={() => onCheckboxClick(item)}
        />
      </CheckboxStyled>
    );
  };

  const checkAll = (
    learners: Entry[],
    filteredAndSortedLearnersList: Entry[],
    setLearners: (entries: Entry[]) => void,
  ): void => {
    const all = [...learners].concat(filteredAndSortedLearnersList);
    setLearners(all);
  };

  const onMasterCheckboxChange = (val: boolean) => {
    if (val) {
      checkAll(checkedLearners, filteredAndSortedList, setCheckedLearners);
    }
    if (!val) {
      setCheckedLearners(checkedLearners.filter((x) => !filteredAndSortedList.some((y) => x._id === y._id)));
    }
  };

  const allLearnersChecked = (): boolean => {
    if (filteredAndSortedList.length === 0) {
      return false;
    }
    return filteredAndSortedList.every((x) => checkedLearners.some((y) => x._id === y._id));
  };

  const renderMasterCheckbox = (): JSX.Element => {
    return (
      <CheckboxStyled>
        <Checkbox
          dataQaId='master-checkbox'
          checked={allLearnersChecked()}
          onChange={(val) => onMasterCheckboxChange(val)}
        />
      </CheckboxStyled>
    );
  };

  useEffect(() => {
    setCheckedLearners(checkedLearners);
  }, [checkedLearners]);

  return (
    <Table<Entry>
      data={filteredAndSortedList}
      noItemsErrorBody={<div data-qa-id={`no-candidates-${qaId}`}>No candidates found</div>}
      onRowClick={(item) => {
        onCheckboxClick(item);
      }}
      columns={[
        {
          renderHeaderCell: function render() {
            return renderMasterCheckbox();
          },
          renderCell: function render(item) {
            return renderSingleCheckbox(item);
          },
          align: 'left',
        },
        ...baseTableCols(sortConfig, setSortConfig, isPartOfConsortia, maxMark, qaId),
      ]}
    />
  );
};
